module.exports = __webpack_public_path__ + "static/media/1-q.95b9b3e4.mp3";